<template>
  <section id="main-box">
    <div class="page-content">
      <div class="table-box layui-body" style="left:0;">

        <div class="xblock-box">
          <div class="xblock layui-form" :class="{'FloatingNav':SelectedNum > 0}">
            <div class="layui-input-inline xblock-row">
              <input type="text" name="username" placeholder="SKU查询" v-on:keydown.13="searchResult" v-model="sku"
                autocomplete="off" class="layui-input" />
            </div>
            <div class="layui-input-inline">
              <button class="layui-btn xblock-row" style="height: 36px;" v-on:click="searchResult"><i
                  class="fa fa-search"></i></button>
            </div>
            <span class="x-right" v-text="'　共有数据：'+count+ '条'"></span>
            <div class="clear-both"></div>
          </div>
        </div>

        <table class="layui-table layui-form" :class="{'FloatingMargin':SelectedNum > 0}">
          <thead>
            <tr>
              <th>图片</th>
              <th>站点店铺</th>
              <th>SKU</th>
              <th>规格</th>
              <th>数量</th>
              <th style="width: 20%;">标题</th>
            </tr>
          </thead>
          <tbody v-viewer v-for="(item,index) in list">
            <tr>
              <td>
                <div class="table_img">
                  <img :src="item.img">
                </div>
              <td v-text="item.country+'-'+item.country_name"></td>
              <td v-text="item.item_sku"></td>
              <td v-text="item.variation_sku"></td>
              <td v-text="item.variation_quantity_purchased"></td>
              <td v-text="item.item_name"></td>
            </tr>
            <tr v-if="item.show">
              <td colspan="14" style="padding:15px;">
                <table class="layui-table layui-form" style="margin:0;">
                  <thead>
                    <tr>
                      <th>编号</th>
                      <th>SKU</th>
                      <th>商品投入</th>
                      <th>其它投入</th>
                      <th>总投入</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="val in item.sku_list">
                      <td v-text="val.model_id"></td>
                      <td v-text="val.model_sku"></td>
                      <td v-text="val.price"></td>
                      <td v-text="val.other_price"></td>
                      <td v-text="val.total"></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- transition -->
        <K-Transition :isLoding="isLoding" v-if="isLoding || count < 1" style="margin-top: 16px;"></K-Transition>

        <!--scroll to top-->
        <div class="scroll-top">
          <i class="fa fa-angle-up" aria-hidden="true"></i>
        </div>

      </div>

      <!-- 分页 -->
      <div class="page-box">
        <div id="pagebox" class="pagebox"></div>
      </div>

      <!-- loading -->
      <K-Loading v-if="loading"></K-Loading>

      <!-- toast -->
      <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    </div>
  </section>
</template>

<script>
  var self, form, layer, laypage, isRefresh, modalbox, list_datas, obj_arr;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  export default {
    name: 'Promote',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition
    },
    data() {
      return {
        SelectedNum: 0,
        isLoding: false,
        id: null,
        ix: 0,
        sku: null,
        itemid: null,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        page: 1,
        count: 0,
        page_num: 20,
        isloding: false,
        list: null,
        backupList: null
      }
    },
    mounted() {
      self = this;
      self.SetNavActive("货代", self.$route.name);
      scrollTop(); //监听滚动置顶

      layui.use(['form', 'layer', 'laydate', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;
        self.VersionCheck(); //版本检测
        var datas = JSON.parse(localStorage.getItem("ExShopee_ProductTotal"));
        var prolist = {},
          x = 0;
        for (let i in datas) {
          let item = datas[i].order_datas.items;
          for (let j in item) {
            let data = item[j]
            data.show = false;
            data.country = datas[i].country;
            data.country_name = datas[i].shop_name;
            if (!prolist.hasOwnProperty(data.variation_id)) {
              prolist[data.variation_id] = data;
              x++
            } else {
              prolist[data.variation_id].variation_quantity_purchased += data.variation_quantity_purchased;
            }
          }
        }
        console.log(prolist);
        self.list = prolist;
        self.backupList = prolist;
        self.count = x;
      });
    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      VersionCheck() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/version/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(res) {
          var json = res.data;
          if (json.code == 200) {
            if (json.datas.version != localStorage.getItem("ExShopee_Version")) {
              localStorage.setItem("ExShopee_Version", json.datas.version);
              window.location.reload(true);
            }
          }
        }).catch(function(error) {
          console.log(error);
        })
      },
      ViewProducts(ix, state) {
        if (state) {
          self.list[ix].show = false;
        } else {
          self.list[ix].show = true;
        }
        self.$forceUpdate();
      },
      searchResult() {
        var list = [];
        if (self.sku) {
          for (let i in self.list) {
            if (self.list[i].item_sku == self.sku) {
              list.push(self.list[i])
            }
          }
        } else {
          list = self.backupList;
        }
        self.list = list;
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .redtxt,
  .greenColor {
    font-weight: bold;
  }

  .cx-box {
    width: 20px;
  }

  .xblock-row {
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/logistics/Product.vue